export enum LegalDocumentAudienceEnum {
    Jobseeker = 'jobseeker',
    Customer = 'customer',
}
